import { Either } from "fp-ts/lib/Either";
import ExceptionEntity from "../../../../domain/entities/ExceptionEntity";
import { GetModuleWithAllRolesResponse } from "../../../../domain/repositories/RoleRepository";

const GetModuleWithRolesInteractionApiImpl = async (moduleId: string): Promise<Either<ExceptionEntity, GetModuleWithAllRolesResponse>> => {
    throw new Error('Not implemented');
}

export default GetModuleWithRolesInteractionApiImpl;